var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91699 16.6667C2.58366 16.6667 2.29199 16.5417 2.04199 16.2917C1.79199 16.0417 1.66699 15.75 1.66699 15.4167V4.58333C1.66699 4.24999 1.79199 3.95833 2.04199 3.70833C2.29199 3.45833 2.58366 3.33333 2.91699 3.33333H17.0837C17.417 3.33333 17.7087 3.45833 17.9587 3.70833C18.2087 3.95833 18.3337 4.24999 18.3337 4.58333V15.4167C18.3337 15.75 18.2087 16.0417 17.9587 16.2917C17.7087 16.5417 17.417 16.6667 17.0837 16.6667H2.91699ZM10.0003 10.375L2.91699 5.72916V15.4167H17.0837V5.72916L10.0003 10.375ZM10.0003 9.125L17.0003 4.58333H3.02116L10.0003 9.125ZM2.91699 5.72916V4.58333V15.4167V5.72916Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.5f11fb01ee2e717a8b29f625e232c413.svg";
export { ForwardRef as ReactComponent };